/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var AudioIcon = createIcon("AudioIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#8F3BF2';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 17.429a2 2 0 011.717-1.98l10-1.429a2 2 0 012.263 1.697l.015.141L32 16v14a4 4 0 11-2-3.465l-.002-8.555-10 1.428L20 31.936V32a4 4 0 11-2-3.465V17.43Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.AudioIcon",
  "replaceColor": true
});